import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { saveData } from './complete_actions_creator';
import { CompleteEffectsService } from './complete_effects.service';
import { concatMap, withLatestFrom, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { IAppState } from '../../../app_state';

@Injectable()
export class CompleteEffects {

  saveData$ = createEffect(() => this.action$.pipe(
    ofType(saveData),
    concatMap(action => of(action).pipe(withLatestFrom(this.store$))),
    map(([_, state]) => {
      let completeState = state['app']['signup']['complete'];
      this.completeEffectService.completeOauthFlow(completeState);
    })),
    {
      dispatch: false
    });


  constructor(private action$: Actions,
              private store$: Store<IAppState>,
              private completeEffectService: CompleteEffectsService
  ) {}
}
